import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-ice px-5 py-16 sm:py-24" data-id="element-122" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-3xl flex-col items-center gap-6 text-center sm:flex-row sm:items-start sm:gap-8 sm:text-left" data-id="element-123" data-mp="1o5q1qgnuw7zz">
        <span className="flex h-24 w-24 shrink-0 flex-col items-center justify-center rounded-full bg-leaf text-white shadow-soft" data-id="element-124" data-mp="1x4la9zedhu6g">
          <ShieldCheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-125" data-mp="19fis8qfttzbf" />
          <span className="mt-0.5 font-display text-xs font-extrabold uppercase" data-id="element-126" data-mp="14g6667ws4w9w">7 Tage</span>
        </span>
        <div data-id="element-127" data-mp="1j4tz06f8qrw5">
          <h2 className="font-display text-2xl font-extrabold tracking-tight text-navy sm:text-3xl" data-id="element-128" data-mp="1j5lsnbpa2fjs">
            „Zufrieden oder Geld zurück“-Garantie
          </h2>
          <p className="mt-3 font-display text-lg font-bold text-leaf" data-id="element-129" data-mp="qnzscsh3n1dm">
            Teste das Material 7 Tage lang.
          </p>
          <p className="mt-3 text-[15px] leading-relaxed text-navy/75" data-id="element-130" data-mp="lo51uq18kdt3">
            Wenn es nicht deinen Erwartungen entspricht oder dir nicht dabei hilft, Stunden an
            Vorbereitung und Stress zu sparen, kannst du innerhalb der Garantiefrist eine
            Rückerstattung beantragen.
          </p>
          <p className="mt-3 text-[15px] font-semibold leading-relaxed text-navy" data-id="element-131" data-mp="yqmbtjl0llnd">
            Keine komplizierten Prozesse. Kontaktiere uns einfach innerhalb der Garantiefrist.
          </p>
        </div>
      </div>
    </section>;
}